import {
  Checkbox,
  Collapse,
  ConfigProvider,
  Popover,
  Slider,
  Switch,
  Modal
} from 'antd'
import Big from 'big.js'
import * as React from 'react'
import { Icon, Switch as NodeSwitch } from '@ui-pc'
import { Knife, Processor, Type } from '@utils/tool'
import wdhPng from '@/two/src/assets/imgs/wdh.png'
import styles from './index.module.scss'

import type { CollapseProps } from 'antd'
export interface NavBread {
  title: string
  href: string
}

export interface MetaInfo {
  title: string
  description: string
  keyword: string
}

export interface DispatchTip {
  isShowDeliveryTime: string
  isShowCustomTips: string
  customTips: string
}

export interface ActivityInfo {
  id: string
  startTime: number
  endTime: number
  groupId: string
  groupType: string
  countdown: number
  isStyle: string
  nowTime: number
  hasActivity: number
  isStarted: number
}

export interface ProductTag {
  fontColor: string
  backgroundColor: string
  tagName: string
  promoType: string
}

export interface ProductList {
  productsAddTime: string
  dispatchTips: DispatchTip
  productsId: string
  productsSkuId: string
  poa: string
  productsName: string
  mainImage: string
  hoverImage: string
  finalPrice: number
  formatFinalPrice: string
  marketPrice: number
  formatMarketPrice: string
  styleFormatFinalPrice: string
  jumpUrl: string
  categoriesNames: string
  categoriesIdList: number[]
  starScore: number
  reviewNum: number
  stocks: number
  activityInfo: ActivityInfo
  saveMoneyDesc: string
  productsStatus: number
  optionsDesc: string
  productTag: ProductTag
}

export interface RootObject {
  categoriesId: number
  categoryName: string
  categoriesDescription: string
  categoriesImg: string
  mCategoriesImg: string
  navBread: NavBread[]
  metaInfo: MetaInfo
  categoriesAuthorityUrl: string
  mCategoriesAuthorityUrl: string
  authorityUrl: string
  subCategoriesList: any[]
  productList: ProductList[]
  productCount: number
  page: number
  pageTotal: number
  maxPrice: number
  formatMaxPrice: string
  minPrice: number
  formatMinPrice: string
}
interface FilterSortProps {
  initData?: RootObject
  filterForm?: any
  data: any[]
  handleChange: Function
  isSearch?: boolean // 搜索页
  hideOnSale?: boolean // 隐藏on sale
  showInStock?: boolean // 显示in stock
  showQuickShip?: boolean
  isFixedFilter?: boolean
}

const FilterSort: React.FunctionComponent<FilterSortProps> = (props) => {
  const { initData, isFixedFilter } = props
  const filterList: any[] = props.data || []
  const handleChange = props.handleChange
  const params = props.filterForm
  const [priceError, setPriceError] = React.useState(false)
  const [minValue, setMinValue]: any = React.useState('')
  const [maxValue, setMaxValue]: any = React.useState('')
  const [wdhObj, setWdhObj]: any = React.useState({})
  const debounSearch = React.useMemo(() => Processor.timeout(), [])
  const identicalNum = minValue === maxValue
  const nonumber = initData.maxPrice === 0
  const showAvailability = props.showInStock || props.showQuickShip

  // 选择属性
  const onSelectAttr = (value: number | string, paramKey?: string) => {
    React.startTransition(() => {
      let ids = params[paramKey]?.split(',') || []
      if (ids.indexOf(value) === -1) {
        ids.push(value)
      } else {
        ids.splice(ids.indexOf(value), 1)
      }
      handleChange({
        [paramKey]: ids.filter((el: string) => el !== '').join(',')
      })
    })
  }

  const handleDefaultChecked = (value?: string, paramKey?: string): boolean => {
    const ids = params[paramKey]?.split(',') || []
    if (ids?.includes(value)) {
      return true
    }
    return false
  }

  const validate = (type: 'max' | 'min', value) => {
    const newMax: any = +props.initData.maxPrice || 9999
    if (
      +value > newMax ||
      (type === 'min' && maxValue && +value > Number(maxValue)) ||
      (type !== 'min' && minValue && +value < Number(minValue))
    ) {
      setPriceError(true)
      return true
    } else {
      setPriceError(false)
      return false
    }
  }
  // 价格处理
  const handlePrice = (
    type: 'max' | 'min',
    value: string | number,
    unskip: boolean = true
  ) => {
    let obj: any = {}
    const newMax: any = +props.initData.maxPrice || 9999

    if (type === 'min') {
      obj.minPrice = value ? value : ''
      setMinValue(value)
    } else {
      obj.maxPrice = value > newMax ? newMax : value ? value : ''
      setMaxValue(value)
    }

    !validate(type, value) &&
      unskip &&
      debounSearch(() => handleChange(obj), 500)

    return Object.values(obj)[0]
  }

  const handlePriceChange = (value: number[] = []) => {
    const [min = 0, max = 0] = value
    handlePrice('min', min, false)
    handlePrice('max', max, false)
  }

  // 鼠标松开才触发筛选
  const handlePriceComplete = (value: number[] = []) => {
    const [min = 0, max = 0] = value
    const obj = {
      minPrice: handlePrice('min', min, false),
      maxPrice: handlePrice('max', max, false)
    }
    handleChange(obj)
  }

  const handleWdhChange = (value: number[] = [], keyName: string) => {
    const [min = 0, max = 0] = value
    const obj = { [`min${keyName}`]: min, [`max${keyName}`]: max }
    setWdhObj({
      ...wdhObj,
      ...obj
    })
  }

  // 鼠标松开才触发筛选
  const handleWdhComplete = (value: number[] = [], keyName: string) => {
    const [min = 0, max = 0] = value
    const obj = { [`min${keyName}`]: min, [`max${keyName}`]: max }
    handleChange(obj)
  }

  React.useEffect(() => {
    React.startTransition(() => {
      const dForm = props.filterForm
      // wdh处理
      const obj = {
        minWidth: dForm.minWidth,
        maxWidth: dForm.maxWidth,
        minDepth: dForm.minDepth,
        maxDepth: dForm.maxDepth,
        minHeight: dForm.minHeight,
        maxHeight: dForm.maxHeight
      }
      setWdhObj({ ...obj })
      // 价格处理
      const min = dForm.minPrice
      const max = dForm.maxPrice
      setMinValue(min)
      setMaxValue(max)
      if (min === '' && max === '') return
      validate('min', min)
      validate('max', max)
    })
  }, [props.filterForm, initData.maxPrice])

  const [isModalOpen, setIsModalOpen] = React.useState(false)

  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const showWdhModal = (e) => {
    e.stopPropagation()
    setIsModalOpen(true)
  }

  const [hasMore, setHasMore] = React.useState([])

  const viewMore = (id) => {
    const ids = [...hasMore]
    if (hasMore.indexOf(id) === -1) {
      ids.push(id)
    } else {
      ids.splice(ids.indexOf(id), 1)
    }
    setHasMore(ids)
  }
  React.useEffect(() => {
    setHasMore([])
  }, [filterList])

  // 价格区域
  const priceRangeNode = () => {
    return (
      <div className={styles['price-range-box']}>
        <div className={styles['slider-range']}>
          <Slider
            range
            step={1}
            min={Number(initData?.minPrice) || 0}
            max={Number(initData.maxPrice) || 9999}
            defaultValue={[
              Number(initData?.minPrice) || 0,
              initData.maxPrice || 9999
            ]}
            value={[minValue || 0, maxValue || initData.maxPrice || 9999]}
            onChange={handlePriceChange}
            onAfterChange={handlePriceComplete}
            tooltip={{
              className: 'sliderToolTip'
            }}
          />
          <p className={styles['text-range']}>
            <span>${initData?.minPrice || '0'}</span>
            <span>${initData?.maxPrice || '9999'}</span>
          </p>
        </div>
        {/* <div className={styles['price-range']}>
          <div className={styles['input-area-wrap']}>
            <span className={styles['area-text']}>Min Price $</span>
            <InputNumber
              onBlur={() => {
                if (Type.isEmpty(minValue)) {
                  handlePrice('min', initData.minPrice)
                }
              }}
              className={styles['input-area']}
              placeholder="min"
              min={0}
              value={minValue}
              onChange={(value) => handlePrice('min', value)}
            />
          </div>

          <span className={styles['input-line']}></span>
          <div className={styles['input-area-wrap']}>
            <span className={styles['area-text']}>Max Price $</span>
            <InputNumber
              onBlur={() => {
                if (Type.isEmpty(maxValue)) {
                  handlePrice('max', initData.maxPrice)
                }
              }}
              className={styles['input-area']}
              placeholder="max"
              max={+props.initData.maxPrice || 9999}
              value={maxValue}
              onChange={(value) => handlePrice('max', value)}
            />
          </div>
        </div>
        {priceError && !nonumber ? (
          <div className={styles['error-tips']}>
            {`Value must be between ${
              minValue && minValue < +props.initData?.maxPrice ? minValue : 0
            } and ${+props.initData?.maxPrice}`}
          </div>
        ) : null} */}
        {/* {nonumber && (
          <div className={styles['error-tips']}>
            Please select a new price range
          </div>
        )} */}
      </div>
    )
  }

  // WDH区域
  const wdhNode = (list) => {
    return (
      <div className={styles['wdh-list']}>
        {list?.map((record) => {
          // 首字母大写
          const keyName =
            record.key?.charAt(0).toUpperCase() + record.key?.slice(1)

          return (
            <section key={record.key} className={styles['wdh-item']}>
              <p className={styles['wdh-label']}>{record.label}</p>
              <div className={styles['slider-range']}>
                <Slider
                  range
                  step={1}
                  min={Number(record?.min)}
                  max={Number(record?.max)}
                  defaultValue={[
                    Number(record?.min) || 0,
                    record?.max || 99999999
                  ]}
                  value={[
                    wdhObj[`min${keyName}`] || 0,
                    wdhObj[`max${keyName}`] || record?.max || 99999999
                  ]}
                  onChange={(val) => handleWdhChange(val, keyName)}
                  onAfterChange={(val) => handleWdhComplete(val, keyName)}
                />
                <p className={styles['text-range']}>
                  <span>
                    {record.min}
                    {record.valueUnit}
                  </span>
                  <span>
                    {record.max}
                    {record.valueUnit}
                  </span>
                </p>
              </div>
            </section>
          )
        })}
      </div>
    )
  }

  // category、普通区域
  const attrNode = (
    options: any[] = [],
    optId?: string,
    isShowImage?: boolean
  ) => {
    const hasViewMore =
      !isShowImage &&
      !['s', 'c', 'p', 'wdh'].includes(optId) &&
      options?.length > 6
    return (
      <div className={styles['attributes-group']}>
        <div
          className={`${styles['attributes-checkbox-group']} ${
            isShowImage && styles['attributes-imgs']
          }`}
          style={{
            height: hasViewMore
              ? hasMore.includes(optId)
                ? `${options?.length * 32}px`
                : '192px'
              : 'auto'
          }}
        >
          {options?.map((o) => {
            const paramKey =
              o.productsOptionsId == 'c' ? 'filterCat' : 'filterValueIds'
            const keyId = o.value + ''
            return isShowImage ? (
              <span
                className={`${styles.imgItem} ${
                  handleDefaultChecked(keyId, paramKey) && styles.imgChecked
                }`}
                key={keyId}
                onClick={() => onSelectAttr(keyId, paramKey)}
              >
                <Icon src={o.filterImagePath} />
              </span>
            ) : (
              <Checkbox
                checked={handleDefaultChecked(keyId, paramKey)}
                key={keyId}
                onChange={() => onSelectAttr(keyId, paramKey)}
              >
                {o.label}
              </Checkbox>
            )
          })}
        </div>
        {hasViewMore && (
          <div className={styles['view-btn']} onClick={() => viewMore(optId)}>
            {hasMore.includes(optId) ? 'View Less' : 'View More'}
          </div>
        )}
      </div>
    )
  }

  // 左侧栏展示/顶部固定几个展示---共用: flash category区域
  const cateFlashAttrNode: React.FC = (options: any[]) => (
    <div className={styles['flash-cate-group']}>
      <Collapse
        className={styles['category-collapse']}
        ghost={true}
        expandIconPosition={'end'}
        expandIcon={({ isActive }) => (
          <i
            className={`iconfont ${
              isActive ? 'icon-pc_-new' : 'icon-a-pc_add-new'
            }`}
          />
        )}
        items={options?.map((k, ki) => {
          const paramKey = 'filterCat'
          return {
            key: ki,
            label: <span>{k.label}</span>,
            children: (
              <div className={styles['attributes-checkbox-group']}>
                {k.children?.map((child) => {
                  const keyId = child.id + ''
                  return (
                    <Checkbox
                      checked={handleDefaultChecked(keyId, paramKey)}
                      key={child.id}
                      onChange={() => onSelectAttr(keyId, paramKey)}
                    >
                      {child.categoriesName}
                    </Checkbox>
                  )
                })}
              </div>
            )
          }
        })}
      />
    </div>
  )

  // 左侧栏展示-默认
  let items: CollapseProps['items'] = filterList.map((k: any, ind) => {
    const options = (k.productsOptionValuesList || [])
      ?.map((attr: any) => {
        const obj = {
          label: attr.productsOptionsValuesName,
          value: attr.productsOptionsValuesId + '',
          ...attr
        }
        return obj
      })
      ?.filter((attr) => attr.productsOptionsId !== 'p')
    const isShowImage = Number(k.isShowImage) === 1
    const renderNode = {
      key: ind,
      label: (
        <>
          <span>{k.productsOptionsName}</span>
          {k.productsOptionsId === 'wdh' && (
            <i className='iconfont icon-pc_wenhao' onClick={showWdhModal}></i>
          )}
        </>
      ),
      className: k.productsOptionsId === 'p' && 'first-slider-node', // 新改版后，此用处不大
      children: (
        <>
          {k.productsOptionsId === 'p' ? priceRangeNode() : null}
          {k.productsOptionsId === 'wdh' ? wdhNode(k.wdhList || []) : null}
          {k.productsOptionsId === 's'
            ? cateFlashAttrNode(options)
            : attrNode(options, k.productsOptionsId + '', isShowImage)}

          {/* {k.productsOptionsId === 'p'
            ? priceRangeNode()
            : k.productsOptionsId === 'wdh'
              ? wdhNode(k.wdhList || [])
              : k.productsOptionsId === 's'
                ? cateFlashAttrNode(options)
                : attrNode(options, k.productsOptionsId + '', isShowImage)} */}
        </>
      )
    }
    return renderNode
  })

  // availability node
  const AvailabilityNode = () => {
    return (
      <div className={styles['attributes-checkbox-group']}>
        <NodeSwitch either={props.showInStock}>
          <Checkbox
            className={styles.styleCheck}
            checked={Number(params.inStock) === 1}
            onChange={(e) => onSwitchChange(e.target.checked, 'inStock')}
          >
            In Stock
          </Checkbox>
        </NodeSwitch>
        <NodeSwitch either={props.showQuickShip}>
          <Checkbox
            className={styles.styleCheck}
            checked={Number(params.quickShip) === 1}
            onChange={(e) => onSwitchChange(e.target.checked, 'quickShip')}
          >
            Quick Ship
          </Checkbox>
        </NodeSwitch>
      </div>
    )
  }

  if (showAvailability) {
    items.push({
      key: '999',
      label: <span>AVAILABILITY</span>,
      children: <AvailabilityNode />
    })
  }

  // 顶部固定几个展示
  const FixedAttrNode: React.FC = (options: any[]) => (
    <div className={styles['attributes-checkbox-group']}>
      {options?.map((o) => {
        const paramKey =
          o.productsOptionsId == 'c' ? 'filterCat' : 'filterValueIds'
        const keyId = o.value + ''

        return (
          <Checkbox
            checked={handleDefaultChecked(keyId, paramKey)}
            key={keyId}
            onChange={() => onSelectAttr(keyId, paramKey)}
          >
            {o.label}
          </Checkbox>
        )
      })}
    </div>
  )
  const FixedItems = filterList?.map((k: any, index: number) => {
    const options = (k.productsOptionValuesList || [])?.map((attr: any) => {
      const obj = {
        label: attr.productsOptionsValuesName,
        value: attr.productsOptionsValuesId + '',
        ...attr
      }
      return obj
    })
    return (
      <div className={styles['fixed-filter-item']} key={index}>
        <Popover
          placement='bottom'
          title={null}
          content={
            k.productsOptionsId === 's'
              ? cateFlashAttrNode(options)
              : FixedAttrNode(options)
          }
          arrow={false}
          overlayClassName={styles['filter-popover']}
          trigger='click'
        >
          <div className={styles['fixed-label']}>
            {k.productsOptionsName} <i className='iconfont icon-pc_zhankai'></i>
          </div>
        </Popover>
      </div>
    )
  })
  const FixedAvailability = () => {
    return (
      <div className={styles['fixed-filter-item']}>
        <Popover
          placement='bottom'
          title={null}
          content={<AvailabilityNode />}
          arrow={false}
          overlayClassName={styles['filter-popover']}
          trigger='click'
        >
          <div className={styles['fixed-label']}>
            AVAILABILITY <i className='iconfont icon-pc_zhankai'></i>
          </div>
        </Popover>
      </div>
    )
  }

  const onSwitchChange = (checked, key) => {
    handleChange({
      [key]: +checked
    })
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Slider: {
            /* 这里是你的组件 token */
            railSize: 3, // 轨道高度
            railBg: '#eee', // 轨道背景色
            railHoverBg: '#eee', // 轨道悬浮
            trackBg: '#886D55',
            trackHoverBg: '#886D55',
            dotBorderColor: '#886D55',
            handleColor: '#886D55',
            handleActiveColor: '#886D55',
            handleSize: 9, // 滑块尺寸
            handleSizeHover: 9, //悬浮态
            handleLineWidth: 1, // 滑块边框宽度
            handleLineWidthHover: 1
          }
        }
      }}
    >
      <NodeSwitch either={isFixedFilter}>
        <>
          {FixedItems}
          <NodeSwitch either={showAvailability}>
            <FixedAvailability />
          </NodeSwitch>

          {/* <NodeSwitch either={props.showInStock}>
            <div className={styles['fixed-filter-item']}>
              <div className={styles['attributes-checkbox-group']}>
                <Checkbox
                  className={styles.fixedStyleCheck}
                  checked={params.inStock == 1}
                  onChange={(e) => onSwitchChange(e.target.checked, 'inStock')}>
                  <div className={styles['fixed-label']}>In Stock</div>
                </Checkbox>
              </div>
            </div>
          </NodeSwitch> */}
        </>
        <div className={styles['attributes-filter']}>
          <Collapse
            items={items}
            ghost={true}
            defaultActiveKey={['0', '1', '2', '999']}
            expandIconPosition={'end'}
            expandIcon={({ isActive }) => (
              <i
                className={`iconfont ${
                  isActive ? 'icon-pc_shouqi' : 'icon-pc_zhankai'
                }`}
              />
            )}
            className={styles['filter-collapse']}
          />

          {!props.hideOnSale && (
            <div className={styles['switch-area']}>
              <div className={styles['switch']}>
                <span>On Sale </span>{' '}
                <Switch
                  key={params.onSale}
                  defaultChecked={params.onSale == 1}
                  onChange={(checked) => onSwitchChange(checked, 'onSale')}
                />
              </div>
            </div>
          )}
          {/* {props.showInStock && (
            // <div className={styles['switch-area']}>
            //   <div className={styles['switch']}>
            //     <span>In Stock </span>{' '}
            //     <Switch
            //       key={params.inStock}
            //       defaultChecked={params.inStock == 1}
            //       onChange={(checked) => onSwitchChange(checked, 'inStock')}
            //     />
            //   </div>
            // </div>
            <div className={styles['attributes-checkbox-group']}>
              <Checkbox
                className={styles.styleCheck}
                checked={params.inStock == 1}
                onChange={(e) => onSwitchChange(e.target.checked, 'inStock')}>
                In Stock
              </Checkbox>
            </div>
          )} */}

          <Modal
            wrapClassName={styles.wdhModal}
            title='Dimensions'
            footer={null}
            centered={true}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
          >
            <img src={wdhPng} />
          </Modal>
        </div>
      </NodeSwitch>
    </ConfigProvider>
  )
}

export default FilterSort
